module.exports = __webpack_public_path__ + "static/media/gibson_weiss.8eca9e4c.jpg";